<template>
    <div class="m-2">
        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Заголовок</span>
            <span class="w-2/3">{{ entity.title }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Описание</span>
            <span class="w-2/3">{{ entity.description }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Дата завершения</span>
            <span class="w-2/3">{{ entity.due_date ? formatDateShort(entity.due_date) : 'Не ограничена' }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Тип</span>
            <span class="w-2/3">{{ typeLabel }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Порядок сортировки</span>
            <span class="w-2/3">{{ entity.sort }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Промокод для награды</span>
            <span class="w-2/3">{{ entity.promocode ? entity.promocode.code : 'Без награды' }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Активен</span>
            <span class="w-2/3">
                <CBadge :color="entity.enabled ? 'success' : 'secondary'">
                    {{ entity.enabled ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>
    </div>
</template>

<script>
    const { formatDate } = require('../../utils/views');
    const { DELIVERY_TYPE } = require('../../utils/order');
    const moment = require('moment');

    export default {
        props: {
            entity: {
                type: Object,
                default: () => {},
            },
        },

        data() {
            return {};
        },
        computed: {
            typeLabel() {
                return this.entity.type === 'one_per_day' ? 'По вопросу в сутки' : 'С наградой';
            },
        },
        created() {
        },

        methods: {
            formatDate(date) {
                return formatDate(date);
            },

            formatDateShort(data) {
                return moment(data).format('DD.MM.YYYY');
            },

        },
    };
</script>
